import moment from 'moment'

export function formatDate (date) {
  return date && (typeof date === 'object') ? moment(date.toDate()).format('MMM Do, YYYY') : null
}
